import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function announcementRequest(id) {
  const response = await api.get(
    generatePath('/announcement/:id', { id }),
    config('json')
  );
  return response.data;
}

export async function sendAnnouncementReactionRequest({ id, reaction_type }) {
  return await api.post(
    generatePath('/announcement_reaction/:id', { id }),
    { reaction_type: reaction_type },
    config('json')
  );
}

export async function deleteAnnouncementReactionRequest({ id }) {
  return await api.delete(
    generatePath('/announcement_reaction/:id', { id }),
    config('json')
  );
}

export async function getAnnouncementCommentsRequest(id) {
  return (
    await api.get(
      '/announcement_comment/',
      config('json', {
        announcement_id: id
      })
    )
  ).data;
}

export async function sendAnnouncementCommentRequest({ id, comment }) {
  return await api.post(
    '/announcement_comment/',
    {
      announcement_id: id,
      comment: comment
    },
    config('json')
  );
}

export async function deleteAnnouncementCommentRequest({ id }) {
  return await api.delete(
    generatePath('/announcement_comment/:id', { id }),
    config('json')
  );
}

export async function editAnnouncementCommentRequest({ id, comment }) {
  return await api.patch(
    generatePath('/announcement_comment/:id', { id }),
    {
      comment: comment
    },
    config('json')
  );
}
